/* eslint-disable import/no-cycle */
import { useEffect } from 'react';
import { Grid, LinearProgress } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import _ from 'lodash';
import { transformDynamicFormValueToFilterPayload } from 'src/components/filters/utils/filter-form-utils';
import useModuleMetadata from 'src/hooks/use-module-metadata.hook';
import ProductCommentsContainer from '../../../planner_v2/components/comments/comment-list';
import { getDataForCommentsV2 } from '../../../planner_v2/components/drawer/drawer-slice';
import ItemHeader from '../../../planner_v2/components/drawer/item-header';
import { CommentDataPayload } from './comment-box-container.model';
import './comment-box-container.scss';
import MODULE_TO_PAGE_MAP from '../../../home/types/simulation-module-to-page-map';

/**
 * Renders the comment box for a selected product (PPG or SKU)
 *  It will list down all the comments, name & image for the selected product (PPG or SKU)
 */
function CommentBoxContainer() {
  const appDispatch = useAppDispatch();
  const {
    commentsData: commentsByMarket,
    fetchingComments,
    selectedRow
  } = useAppSelector((state) => state.drawerManager);
  const {
    globalFilterCombinations,
    globalFilterFormFields,
    globalFilterValue
  } = useAppSelector((state) => state.filters);
  const { scenarioId, sourceId } = useModuleMetadata({
    module: MODULE_TO_PAGE_MAP.PRICING
  });

  useEffect(() => {
    const filters = transformDynamicFormValueToFilterPayload({
      formValue: globalFilterValue,
      formFields: globalFilterFormFields,
      combinations: globalFilterCombinations
    });
    const payloadData: {
      commentData: CommentDataPayload;
      scenarioId: number;
      sourceId: number;
    } = {
      commentData: {
        ...selectedRow,
        filter_inputs: filters
      },
      scenarioId,
      sourceId
    };
    appDispatch(getDataForCommentsV2(payloadData));
  }, []);

  return (
    <div>
      {fetchingComments ? (
        <Grid item xs={12}>
          <LinearProgress />
        </Grid>
      ) : null}
      {!fetchingComments && !_.isEmpty(commentsByMarket) && (
        <>
          {!_.isEmpty(commentsByMarket.details) && (
            <ItemHeader
              name={
                commentsByMarket.details ? commentsByMarket.details.name : ''
              }
              imgSrc={
                commentsByMarket.details ? commentsByMarket.details.icon : ''
              }
              isExpandable={false}
              isOpen={false}
              onExpandToggleClick={() => {}}
              // eslint-disable-next-line react/jsx-boolean-value
              showImage={true}
            />
          )}

          {Object.keys(commentsByMarket.comments_data).length ? (
            Object.keys(commentsByMarket.comments_data)
              .map(
                (commentByMarket) =>
                  commentsByMarket.comments_data[commentByMarket]
              )
              .map((marketDetails) =>
                marketDetails.comments_data.length ? (
                  marketDetails.comments_data.map((commentData) => (
                    <>
                      <div className='channel-name-container'>
                        {marketDetails.alias} :{' '}
                        {commentData[marketDetails.name]}
                      </div>
                      <ProductCommentsContainer
                        comments={commentData.comments_data}
                        onCommentUpdate={null}
                        onCommentDelete={null}
                        isActionVisible={false}
                        maxHeight={200}
                      />
                    </>
                  ))
                ) : (
                  <div className='empty-comment-box'>
                    {' '}
                    Comments are not present
                  </div>
                )
              )
              .flat(1)
          ) : (
            <div className='empty-comment-box'> Comments are not present</div>
          )}
        </>
      )}
    </div>
  );
}

export default CommentBoxContainer;
